<template>
  <div class="content-container" style="padding-top: 50px">
    <div class="nav-bar">
      <a-select default-value="-1" style="width: 120px" @change="handleChangePublic">
        <a-select-option value="-1">{{$t('moduleTitles.all')}}</a-select-option>
        <a-select-option value="1">{{$t('publish.public')}}</a-select-option>
        <a-select-option value="0">{{$t('publish.pravite')}}</a-select-option>
      </a-select>
      <div class="sort-wrapper">
        <ul>
          <li>
            <a
              :class="isSort('create_time')?'sort-active':''"
              @click="onChangeSort('create_time')"
            >{{$t('actionTitles.timeOrder')}}</a>
          </li>
          <li>
            <a
              :class="isSort('total_browse')?'sort-active':''"
              @click="onChangeSort('total_browse')"
            >{{$t('actionTitles.viewsOrder')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <van-search v-model="searchForm.name" :placeholder="$t('message.workSearch')" @search="onRefresh" />
    <div style="padding: 0px 10px 0 10px">
      <a-breadcrumb v-show="folderDepthList.length>0">
        <a-breadcrumb-item>
          <a @click="queryByPid(0)">{{$t('moduleTitles.root')}}</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item,index) in folderDepthList" :key="index">
          <a @click="queryByPid(item.id)">{{item.name}}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="work-wrapper" v-for="work in releaseList" :key="work.id">
      <div class="info-wrapper" @click.stop="toTour(work)">
          <div>
            <div class="info-title">{{work.name}}</div>
              <div class="info-description">{{work.user_name}}</div>
          </div>
          <div style="margin-top:15px;">
            <img src="@/assets/img/publishing.gif">
            <p>{{$t('message.workAwait')}}</p>
          </div>
          <div>
            <img style="width: 65px; height: 65px" :src="work.thumb_path" />
          </div>
        </div>
        <div class="opration-wrapper">
            <van-button
              size="mini"
              type="primary"
              round
              @click="deleteAsync(work.id)"
            >{{$t('actionTitles.delete')}}</van-button>
        </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished"  @load="onLoadMore"  :immediate-check="false">
        <div class="work-wrapper" v-for="work in workList" :key="work.id">
          <div v-if="work.dir_id == undefined">
            <div class="dir-wrapper">
              <div class="title-wrapper" @click="toFolder(work.id)">
                <div>
                  <img style="width: 40px; height: 40px" src="@/assets/img/fold.png" />
                </div>
                <div class="dir-title">{{work.name}}</div>
              </div>
              <popover-action>
                <van-button size="mini" type="primary" round>
                  <a-icon type="ellipsis" />
                </van-button>
                <template slot="content">
                  <popover-action-item :title="$t('actionTitles.moveTo')" @click="onMoveClick(work.id)"></popover-action-item>
                  <popover-action-item :title="$t('actionTitles.rename')" @click="onRenameClick(work.id)"></popover-action-item>
                  <popover-action-item :title="$t('actionTitles.delete')" @click="onDelete(work.id)"></popover-action-item>
                </template>
              </popover-action>
            </div>
          </div>
          <div v-else>
            <div class="info-wrapper">
              <div @click.stop="toTour(work)">
                <div class="info-title">{{work.name}}</div>
                <div class="info-description">{{work.regoin_name}}</div>
                <div class="info-description" v-if="work.customer_name">
                  <span class="m-r-10">{{work.customer_name}}</span>
                  <span>{{work.customer_phone}}</span>
                </div>
              </div>
              <div @click.stop="toTour(work)">
                <img style="width: 65px; height: 65px" :src="work.thumb_path" />
              </div>
            </div>
            <div class="opration-wrapper">
              <van-button
              v-if="work.type==1"
                size="mini"
                round
                @click="onClickEdit(work)"
              >{{$t('actionTitles.edit')}}</van-button>
              <van-button
                size="mini"
                type="primary"
                round
                @click="share(work)"
              >{{$t('actionTitles.share')}}</van-button>
              <popover-action class="more-span">
                <van-button size="mini" type="primary" round>
                  <a-icon type="ellipsis" />
                </van-button>
                <template slot="content">
                  <popover-action-item :title="$t('actionTitles.moveTo')" @click="onMoveClick(work.id)"></popover-action-item>
                  <popover-action-item :title="$t('actionTitles.delete')" @click="onDelete(work.id)"></popover-action-item>
                </template>
              </popover-action>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <a-modal
      v-model="shareVisible"
      :title="$t('actionTitles.share')"
      :width="800"
      :destroyOnClose="true"
      @ok="() => this.shareVisible = false"
      :footer="null"
    >
      <share :share-type="shareType" :work-id="shareWorkId" :is-only-qr="true" ></share>
    </a-modal>

    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="onRenameConfirm">
      <div>
        <div>
          <a-input v-model="renameObj.name" :addonBefore="$t('edit.name')"></a-input>
        </div>
      </div>
    </a-modal>

    <a-modal
      v-model="treeVisible"
      :title="$t('actionTitles.moveTo')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="moveTo"
    >
      <a-directory-tree
        :loadedKeys="loadedKeys"
        :replaceFields="{children:'children', title:'name', key:'id'}"
        :load-data="onLoadData"
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
      />
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup, List, PullRefresh, Search, Button, Progress } from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List);
Vue.use(Search);
Vue.use(PullRefresh);
Vue.use(Button);
Vue.use(Progress);

import path from "path";
import {
  getWorkDetail,
  getWorkList,
  createFolder,
  softDelete,
  getTreeDir,
  getFolderDepth,
  moveDir,
  releaseWork,
  deleteAsync,
  recommend,
} from "@/api/work";
import Share from "@/components/Share";
import PopoverAction from "../../components/PopoverAction";
import PopoverActionItem from "../../components/PopoverActionItem";

import JSZip from "jszip";
import FileSaver from "file-saver";
import { getFile } from "@/utils/downloadFile";
import { baseUrl } from "@/config";

export default {
  data() {
    return {
      searchForm: {
        pid: 0,
        name: "",
        cate: undefined,
        is_public: [],
        order: { create_time: "desc" },
      },
      refreshing: false,
      loading: false,
      finished: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      workList: [],
      releaseList: [],
      timeout: undefined,
      tableData: [],
      shareVisible: false,
      shareWorkId: 0,
      shareType: "tour",
      shareThumbPath: "",
      renameVisible: false,
      renameObj: {},

      treeVisible: false,
      selectedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      folderDepthList: [],
      selectDirIds: [],
      loadedKeys: [],
      asyncCount:0,
      asyncLoading:false,
      moveLoading:false
    };
  },
  components: { Share, PopoverAction, PopoverActionItem },
  computed: {},
  mounted() {
    this.onRefresh();
    this.getReleaseWork();
    this.timeout = setInterval(() => {
      this.getReleaseWork();
    }, 7000);
  },
  destroyed(){
    //頁面銷毀 銷毀定時任務
    window.clearInterval(this.timeout);
  },
  methods: {
    getKey(item) {
      if (item.dir_id == undefined) {
        return "dir" + item.id;
      } else {
        return item.id + "";
      }
    },
    getId(key) {
      return key.replace("dir", "");
    },
    handleChangePublic(value) {
      if (value == -1) {
        this.searchForm.is_public = [];
      } else {
        this.searchForm.is_public = [value];
      }
      this.onRefresh();
    },
    onClickEdit(record) {
      this.$router.push({ path: "/mobile/edit", query: { id: record.id } });
    },
    getReleaseWork() {
      releaseWork().then((res) => {
        console.log("===获取发布中作品===", this.asyncCount, res.data.length)
        if(this.asyncCount!=res.data.length){
          console.log("===发布中作品有变化===")
          this.onRefresh();
          this.asyncCount = res.data.length;
        }
        this.releaseList = res.data;
        if (res.data.length <= 0) {
          this.asyncCount = 0
          window.clearInterval(this.timeout);
        }
      });
    },
    deleteAsync(id) {
      deleteAsync({ id: id }).then((res) => {
        if (res.code) {
          this.$message.success(this.$t("message.deleteSuccess"));
          this.getReleaseWork();
        }
      });
    },
    isSort(field) {
      return this.searchForm.order[field] != undefined;
    },
    onChangeCate() {
      this.onRefresh();
    },
    onChangeSort(field) {
      this.searchForm.order = { [field]: "desc" };
      this.onRefresh();
    },
    onRefresh() {
      this.selectedRowKeys = [];
      this.pagination.current = 1;
      this.finished = false;
      this.refreshing = true;
      this.loading = true;
      this.loadData();
      getFolderDepth({ id: this.searchForm.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    onLoadMore() {
      this.pagination.current += 1;
      this.loadData();
    },
    loadData() {
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };

      getWorkList(this.searchParam)
        .then((ret) => {
          this.loading = false;
          let data = ret.data.records.map((item) => {
            item.id = this.getKey(item);
            return item;
          });

          if (this.pagination.current === 1) {
            this.workList = data;
          } else {
            this.workList = [...this.workList, ...data];
          }
          this.refreshing = false;

          if (data.length < this.pagination.pageSize) {
            this.finished = true;
          }
          this.pagination.total = ret.data.total;

        })
        .catch(() => {
          this.loading = false;
        });

    },
    share(item) {
      this.shareType = item.type==2 ? "live" : "tour";
      // this.shareWorkId = +item.id;
      this.shareThumbPath = item.thumb_path;
      this.shareVisible = true;
      this.shareWorkId = item.uuid;
    },
    toTour(item) {
      const { href } = this.$router.resolve({
        path: (item.type==2 ? "/live/" : "/tour/") + `${item.uuid}`,
      });
      window.open(href, "_blank");
    },
    onRenameClick(key) {
      this.renameObj = this.workList.find((p) => {
        return p.id == key;
      });
      this.renameVisible = true;
    },
    onRenameConfirm() {
      createFolder({
        ...this.renameObj,
        ...{ id: this.getId(this.renameObj.id) },
      })
        .then(() => {
          this.onRefresh();
          this.$message.success(this.$t("message.saveSuccess"));
          this.renameVisible = false;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    onDelete(key) {
      let deletelist = [
        { id: this.getId(key), type: key.indexOf("dir") > -1 ? "dir" : "pano" },
      ];
      softDelete(deletelist).then(() => {
        this.$message.success(this.$t("message.deleteSuccess"));
        this.onRefresh();
      });
    },
    onLoadData(treeNode) {
      return new Promise((resolve,reject) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }else{
          setTimeout(() => {
            getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
              if (res.code && res.data.length) {
                // 找出已選的資料夾ID
                let dir = [];
                this.selectedRowKeys.forEach((key) => {
                  if (key.indexOf("dir") > -1) {
                    dir.push(parseInt(this.getId(key)));
                  }
                });
                // 清除自己所屬之資料夾
                let data = res.data.filter((item) => {
                  if (!dir.includes(item.id)) {
                    return item;
                  }
                });

                if(data.length) {
                  treeNode.dataRef.children = data
                }else{
                  treeNode.dataRef.isLeaf = true
                }
              } else {
                treeNode.dataRef.isLeaf = true;
              }
              this.treeData = [...this.treeData];
              resolve();
            });
          }, 1);
        }
        
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    toFolder(key) {
      this.searchForm.pid = this.getId(key);
      this.pagination.current_page = 1;
      this.onRefresh();
    },
    queryByPid(pid) {
      this.searchForm.pid = pid;
      this.pagination.current_page = 1;
      this.onRefresh();
    },
    onMoveClick(key) {
      this.selectedRowKeys = [key];
      //移動到
      this.selectDirIds = [];
      this.selectedRowKeys.map((key) => {
        if (key.indexOf("dir")) {
          this.selectDirIds.push(this.getId(key));
        }
      });
      (this.treeData = [{ id: 0, name: this.$t("moduleTitles.root") }]),
        (this.treeVisible = true);
      this.selectedKeys = [];
      this.loadedKeys = [];
    },
    async moveTo() {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning(this.$t("message.moveSelectHint"));
        return;
      }
      if(this.moveLoading) return false
      this.moveLoading = true
      let dir = []
      let pano = []
      this.selectedRowKeys.forEach((key) => {
        if (key.indexOf("dir") > -1) {
          dir.push(this.getId(key));
        } else {
          pano.push(this.getId(key));
        }
      });
      if(dir.length){
        //取得第二和第三層資料夾ID
        let target = this.treeData[0].children
        let allDeep3ID = []
        let allDeep2ID = []
        if(target){
          for(let i = 0;i<target.length;i++){
            allDeep2ID.push(target[i].id)
            if(target[i]?.children) {
              for(let j = 0;j<target[i].children.length;j++){
                allDeep3ID.push(target[i].children[j].id)
              }
            }
          }
        }
        //取得移動目標是否包含資料夾
        let payload = {
          current_page:1,
          name:'',
          is_public: [],
          order:{
            create_time:'desc'
          },
          per_page:10,
          pid:0,
        }
        let hasDir = false
        for(let index = 0;index<dir.length;){
          payload.pid = dir[index]
          await getWorkList(payload)
            .then((res) => {
              if (res.code === 1) {
                hasDir = res.data.records.some((item)=> item.pid)
              }
            })
            .catch((error) => {
              console.log('error',error)
          });
          if(hasDir){
            break
          }else{
            // 延遲callAPI時間
            await new Promise(resolve => {
              setTimeout(() => {
                index++
                resolve()
              }, 200)
            });
          }
        }
        //當移動作品包括資料夾時，移動後不可超出三層資料夾
        if((allDeep3ID.includes(this.selectedKeys[0])) || (allDeep2ID.includes(this.selectedKeys[0]) && hasDir)) {
          this.$message.warning(this.$t("message.moveFail"))
          this.moveLoading = false
          return false
        }
      }
      let param = { to: this.selectedKeys[0], dir, pano };
      moveDir(param).then((res) => {
        this.$message.success(this.$t("message.moveSuccess"));
        this.treeVisible = false;
        this.onRefresh();
        this.moveLoading = false
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-container {
  background: #fff;
  min-height: 100vh;
}

.nav-bar {
  width: 100%;
  height: 50px;
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 10px;
}

.sort-wrapper {
  display: flex;
  align-items: center;
  ul {
    margin-bottom: 0;
    li {
      display: inline;
      margin-left: 10px;
      a {
        padding: 8px 12px;
        color: black;
        font-size: 15px;
      }
      .sort-active {
        background-color: rgba(247, 247, 247, 1);
        padding: 8px 12px;
        color: #1890ff;
        border-radius: 20px;
        font-size: 15px;
      }
    }
  }
}

.work-wrapper {
  padding: 10px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .info-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /*align-items: center;*/
    .info-title {
      font-size: 1rem;
      color: rgba(0, 0, 0, 1);
      font-weight: 700;
    }
    .info-description {
      font-size: 0.8rem;
      color: gray;
      margin-top: 2px;
      span{
        display: inline-block;
      }
      .m-r-10{
        margin-right: 10px;
      }
    }
  }
  .dir-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 10px 0;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    .title-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .dir-title {
        margin-left: 10px;
        font-size: 0.8rem;
        font-weight: 700;
      }
    }
  }
  .opration-wrapper {
    padding: 10px 0 10px 0;
    // border-color: #ccc;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
  }
}

.van-button__content {
  padding: 10px;
}
.van-button--primary {
  color: rgba(64, 64, 64, 1);
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(247, 247, 247, 1);
}
.van-button--default{
  color: #ffffff;
  background-color: #0a67fb;
  border: 1px solid #0a67fb;
}
  .more-span{
    margin-left: 4px;
  }
</style>
